import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';
import logger from 'src/utils/logger';
class CommandClass {
    $q;
    constructor() {
        this.$q = useQuasar();
    }
    static SupportedMethods = ['testTask', 'schedule', 'setEnabled'];
    static TargetApps = 'apps';
    static TargetMiners = 'miners';
    isValidCommand(commandData) {
        if ((!commandData.devices || commandData.devices.length === 0) &&
            !CommandClass.SupportedMethods.includes(commandData.method)) {
            this.$q.store.dialog.set({
                show: true,
                title: 'No miners selected',
            });
            return false;
        }
        return commandData.to === CommandClass.TargetApps || commandData.to === CommandClass.TargetMiners;
    }
    buildAppRequest(commandData) {
        return {
            type: 'query',
            iface: 'user',
            method: 'sendToServer',
            args: {
                id: commandData.serverID,
                method: commandData.method,
                args: {
                    devices: commandData.devices,
                    action: commandData.action,
                    params: commandData.params || undefined,
                },
            },
        };
    }
    buildMinerRequest(commandData) {
        return {
            type: 'query',
            iface: 'user',
            method: 'sendToMiner',
            args: {
                farm_id: commandData.farmID,
                id: commandData.devices,
                method: commandData.method,
                action: commandData.action,
                params: commandData.params || undefined,
            },
        };
    }
    async send(commandData) {
        if (!this.isValidCommand(commandData))
            return false;
        const requestData = commandData.to === CommandClass.TargetApps
            ? this.buildAppRequest(commandData)
            : this.buildMinerRequest(commandData);
        if (commandData.method === 'networkConf') {
            logger.log('networkConf request:', requestData);
        }
        return await this.$q.ws.sendRequest(requestData);
    }
}
export default CommandClass;
